import { useDrop } from 'react-dnd';

export default function getDrop(dndType, ref, index, onMoveFile, onDropComplete) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [, drop] = useDrop({
    accept: dndType,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = monitor.getItem().index;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect();

      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      onMoveFile(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
    drop(item) {
      if (onDropComplete) {
        onDropComplete(item.index);
      }
    },
  });

  return drop;
}
